import { z } from "zod";

/**
 * A phone that can receive pushes for its owner's alerts.
 *
 * Nothing sends a push yet. The token is collected now so that turning
 * notifications on later is wiring an existing column to a sender, rather
 * than a migration plus an app release plus waiting for customers to open
 * the app again before any of them can be notified.
 *
 * The format is checked only for length. Expo has changed the token prefix
 * before (`ExponentPushToken[...]`, and `ExpoPushToken[...]` since), and a
 * regex pinned to today's spelling would silently stop registering devices
 * the next time it changes -- a failure nobody sees until the pushes that
 * were meant to arrive do not.
 */
export const RegisterDevice = z.object({
  expoPushToken: z.string().min(8).max(256),
});
export type RegisterDevice = z.infer<typeof RegisterDevice>;
